import layout from './layout'
import elements from './elements'

const S = { layout, elements }

export default S
